import React from 'react';
import PropTypes from 'prop-types';
import SrNativeAppBanner from 'client/components/SrNativeAppBanner';

const SrNavbarContainer = ({
  children,
}) => {
  return (
    <div className='SrNavbarContainer'>
      <SrNativeAppBanner />
      {children}
    </div>
  );
};

SrNavbarContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

SrNavbarContainer.displayName = 'SrNavbarContainer';

export default SrNavbarContainer;
